import { t } from 'ttag'

import { Heading } from '@h2/components/typography/heading'
import { TargetedRangeChart } from '@h2/components/display/targetedRangeChart'
import { Box } from '@h2/components/layout/box'
import { PB97T } from '@h2/components/colors'
import { Text } from '@h2/components/typography/text'

const FinancialSummaryCard = ({ objectType, financial }) => {
  const formatCurrency = amt =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(amt)
  const occupationFinancialContent = () => {
    const budgetAmount = formatCurrency(financial.budget)
    const avgWage = formatCurrency(financial.averageWage)

    if (financial.budget <= 0) {
      return <Text align="center">{t`You have not yet completed a budget`}</Text>
    }

    return (
      <>
        <p>
          {financial.budget <= financial.averageWage
            ? t`Your budget of ${budgetAmount} would be satisfied by the this occupation's average salary of: ${avgWage}`
            : t`This occupation would likely not satisfy your budget of ${budgetAmount} as the average salary is: ${avgWage}`}
        </p>
        <Box width="100%">
          <TargetedRangeChart
            globalMax={200000}
            globalMin={0}
            innerMin={financial.lower25}
            innerMax={financial.upper75}
            innerShadowColor={PB97T}
            secondTarget={(financial.averageWage * 100) / 200000}
            size="large"
            target={(financial.budget * 100) / 200000}
            variant="balloon"
          />
        </Box>
      </>
    )
  }
  const collegeFinancialContent = () => {
    const maxDesiredTuition = formatCurrency(financial.maxDesiredTuition)
    const annualTuition = formatCurrency(financial.annualTuition)

    return (
      <>
        <p>
          {financial.maxDesiredTuition >= financial.annualTuition
            ? t`Your budget of ${maxDesiredTuition} is less than this institution's annual tuition of: ${annualTuition}`
            : t`This occupation would likely not satisfy your budget of ${maxDesiredTuition} as the annual tuition of: ${annualTuition}`}
        </p>
      </>
    )
  }
  const innerContent = () => {
    switch (objectType) {
      case 'cluster':
      case 'onet':
        return occupationFinancialContent()
      case 'college':
        return collegeFinancialContent()
      default:
        return <Text align="center">{`This information is not available`}</Text>
    }
  }

  return (
    <div>
      <Heading level="5">{t`Financial Compatibility`}</Heading>
      {innerContent()}
    </div>
  )
}

export { FinancialSummaryCard }
